const sortReviewsFunction = function() {
  const reviewsSelectsContainer = document.querySelector('.stamped-sort-select-wrapper');
  const sortReviewsHTML = `<p class="sort-reviews-label">Sort reviews:</p>`;

  if (!reviewsSelectsContainer) return;
  reviewsSelectsContainer.insertAdjacentHTML('afterbegin', sortReviewsHTML);
}

const noReviewsUpdate = function() {
  const stampedContainer = document.querySelector('.stamped-container');
  if (!stampedContainer) return;
  if (stampedContainer.getAttribute('data-count') == 0) {

    const yesReviews = document.querySelectorAll('.product-reviews__container > .yes-reviews');
    const noReviews = document.querySelectorAll('.product-reviews__container > .no-reviews');

    yesReviews.forEach(el => {
      el.classList.add('hidden');
    })

    noReviews.forEach(el => {
      el.classList.remove('hidden');
    })
  }
}

window.addEventListener('load', function() {
  setTimeout(() => {
    sortReviewsFunction();
    noReviewsUpdate();
  }, 2000);
})